var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastWeek({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Last week") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Last-week",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1D3066",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 2.75,
    width: 22.5,
    height: 18.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,1.75 C21.6213203,1.75 22.1838203,2.00183983 22.5909903,2.40900974 C22.9981602,2.81617966 23.25,3.37867966 23.25,4 L23.25,4 L23.25,7.25 L0.75,7.25 L0.75,4 C0.75,3.37867966 1.00183983,2.81617966 1.40900974,2.40900974 C1.81617966,2.00183983 2.37867966,1.75 3,1.75 L3,1.75 Z",
    id: "Rectangle",
    stroke: "#1D3066",
    strokeWidth: 1.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1D3066",
    x: 6,
    y: 0,
    width: 1.5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#1D3066",
    x: 16,
    y: 0,
    width: 1.5,
    height: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 12.5,
    cy: 16.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4444444,9 C16.6172626,9 20,12.3827374 20,16.5555556 C20,20.7283737 16.6172626,24.1111111 12.4444444,24.1111111 C12.0762546,24.1111111 11.7777778,23.8126343 11.7777778,23.4444444 C11.7777778,23.0762546 12.0762546,22.7777778 12.4444444,22.7777778 C15.8808829,22.7777778 18.6666667,19.991994 18.6666667,16.5555556 C18.6666667,13.1191171 15.8808829,10.3333333 12.4444444,10.3333333 C9.14586902,10.3333333 6.44678954,12.9000806 6.23553513,16.145246 C6.46742091,16.068489 6.73197711,16.1225014 6.91584897,16.3063733 C7.15016354,16.5406878 7.173595,16.9060284 6.98614334,17.1665481 L6.91584897,17.2491823 L6.02696008,18.1380712 C5.7926455,18.3723858 5.42730496,18.3958172 5.16678519,18.2083656 L5.08415103,18.1380712 L4.19526215,17.2491823 C3.93491262,16.9888328 3.93491262,16.5667228 4.19526215,16.3063733 C4.38591394,16.1157215 4.66330995,16.0646824 4.90040604,16.153256 C5.10807636,12.167897 8.4063094,9 12.4444444,9 Z M9.55555556,22.3 C9.92374539,22.3 10.2222222,22.5984768 10.2222222,22.9666667 C10.2222222,23.3348565 9.92374539,23.6333333 9.55555556,23.6333333 C9.18736572,23.6333333 8.88888889,23.3348565 8.88888889,22.9666667 C8.88888889,22.5984768 9.18736572,22.3 9.55555556,22.3 Z M7.33333333,20.3333333 C7.70152317,20.3333333 8,20.6318102 8,21 C8,21.3681898 7.70152317,21.6666667 7.33333333,21.6666667 C6.9651435,21.6666667 6.66666667,21.3681898 6.66666667,21 C6.66666667,20.6318102 6.9651435,20.3333333 7.33333333,20.3333333 Z M12.1666667,12.1111111 C12.5348565,12.1111111 12.8333333,12.4095879 12.8333333,12.7777778 L12.833,16.884 L14.485562,18.5360243 C14.7459115,18.7963738 14.7459115,19.2184838 14.485562,19.4788333 C14.2252124,19.7391829 13.8031025,19.7391829 13.5427529,19.4788333 L11.508,17.444 L11.5,17.4444444 L11.5,12.7777778 C11.5,12.4095879 11.7984768,12.1111111 12.1666667,12.1111111 Z",
    id: "Combined-Shape",
    fill: "#1D3066",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastWeek);
export default __webpack_public_path__ + "static/media/last_week.e839620e057e9c5746dc9d5b0c02b8ff.svg";
export { ForwardRef as ReactComponent };